<template>
	<div class="country-detail">
		<img :src="'/static/img/flags/'+vModel.FlagCode+'.png'" alt="" />
		<h4 class="text-uppercase">
			{{vModel.FullName}} <br />
			<span class="country">{{vModel.Country}}</span>
		</h4>
	</div>    
</template>
<script>
import CommonService from "../services/common";
export default {
  name: "UserCountrySection",
  created() {
		this.vModel  = CommonService.getUserDetailInformation();
	},
	data() {
		return { vModel : {
			Country:null,
			FlagCode : null,
			FullName : null
		}
		};
	}
};
</script>


